module.exports = __webpack_public_path__ + "img/StarBorderOutlined.a3d57654.svg";